import React from "react";
import type { SxProps, Theme } from "@mui/material";
import { Box, Typography } from "@mui/material";

export interface FieldsetProps {
  title?: string;
  required?: boolean;
  color?: string;
  titleSize?: string | number;
  borderWidth?: number;
  borderRadius?: number;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function Fieldset({ title, required = false, children }: FieldsetProps) {
  return (
    <Box
      component="fieldset"
      sx={{
        height: "100%",
        width: "100%",
        padding: 0,
        borderWidth: 1,
        borderRadius: 2,
        borderStyle: "dashed",
        borderColor: "divider",
        "& legend": {
          color: "primaryText",
          padding: "0 8px",
          borderRadius: "4px",
          marginLeft: "8px",
        },
      }}
    >
      {title && (
        <Typography
          component="legend"
          sx={{
            color: "inherit",
            fontSize: "1rem",
          }}
        >
          {title}
          {required ? " *" : ""}
        </Typography>
      )}
      <Box
        component="div"
        sx={{
          margin: "15px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
